// extracted by mini-css-extract-plugin
export default {"social":"Social_social__pTNGU"};